module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"doors":"Eintritt","timeFrame":"Zeitraum","NEXT_EVENT":"Nächstes Event"},"en":{"doors":"Doors","timeFrame":"Time Frame","NEXT_EVENT":"Next Event"}}')
  delete Component.options._Ctor
}
